import React from 'react';
import { QuestionnaireView } from './useGetLastQuestionnaireByPatientCodexId';

export interface KidneyStones extends QuestionnaireView {
  answer: { stringResponse: string }[];
}

interface KidneyStonesBlockProps {
  questionnaire: KidneyStones[];
}

const KidneyStonesBlock: React.FC<KidneyStonesBlockProps> = ({
  questionnaire = [],
}) => {
  if (
    !questionnaire.length ||
    !questionnaire?.[0]?.answer?.filter(
      ({ stringResponse }) => !!stringResponse,
    )?.length
  ) {
    return null;
  }
  return (
    <div className="grid text-med-gray-3 font-medium gap-x-5 gap-y-2.5 grid-cols-12 ml-5 mt-5">
      <p className="col-span-5 text-neutral-800 font-semibold">
        Date kidney stones occurred
      </p>
      <p className="col-span-4 text-neutral-800 font-semibold">
        Type of kidney stones
      </p>
      <p className="col-span-3 text-neutral-800 font-semibold">Qty of stones</p>
      {questionnaire
        .map(({ answer }) => answer)
        .map(([date, type, qty]) => {
          return (
            <>
              <p className="col-span-5">{date?.stringResponse}</p>
              <p className="col-span-4">{type?.stringResponse}</p>
              <p className="col-span-3"> {qty?.stringResponse}</p>
            </>
          );
        })}
    </div>
  );
};

export default KidneyStonesBlock;
